/**
 *
 * @module purchaseClientEndpoint
 * @see https://github.com/STRML/keyMirror
 *
 */

/* eslint new-cap: 'off' */

import KeyMirror from 'keymirror';

/**
 *
 * @typedef PurchaseClientEndpoint
 * @type {Object}
 *
 * @property {String} redeemPurchases
 * @property {String} restorePurchases
 *
 */

/**
 *
 * @enum
 * @type {PurchaseClientEndpoint}
 *
 */
export default KeyMirror({
    /**
     *
     * @access public
     * @type {String}
     *
     */
    redeemPurchases: null,
    /**
     *
     * @access public
     * @type {String}
     *
     */
    restorePurchases: null
});



// WEBPACK FOOTER //
// ./src/services/purchase/purchaseClientEndpoint.js